module.exports = "<div class=\"pageContent paddingLight classicArea\">\n  <ui-view autoscroll=\"true\"/>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/registration/registration.html
// module id = 1008
// module chunks = 0